<script>
import simplebar from "simplebar-vue";

import useVuelidate from "@vuelidate/core";
import {
  ref,
  reactive,
  nextTick,
  watchEffect,
  onMounted,
  toRef,
  watch,
} from "vue";
//import logo101 from "@/assets/images/101agent.png";
//import userdummy from "@/assets/images/clara.png";
//import sendsvg from "@/assets/images/send.svg";
//import mic_on from "@/assets/images/mic_on.svg";
//import mic_off from "@/assets/images/mic_off.svg";
//import attach from "@/assets/images/attach.svg";
import AudioPlayer from "./audio-player.vue";
import WaitAudio from "./wait-audio.vue";
import iconsvg from "./iconsvg.vue";
import { eventBus } from "@/eventBus";
/**
 * Chat Component
 */
export default {
  emits: [
    "minimize",
    "deactivateVoiceMode",
    "activateVoiceMode",
    "onUploadFile",
    "onMsgSend",
  ],
  props: {
    logo101url: {
      type: String,
      required: true,
    },
    colors: {
      type: Object,
      required: true,
    },
    active: {
      type: Boolean,
      required: true,
      default: true,
    },
    messages: {
      type: Array,
      required: true,
    },
    user: {
      type: String,
      required: true,
      default: "Me",
    },
    agent_photo_url: {
      type: String,
      default: "",
      required: true,
    },
    agent_name: {
      type: String,
      default: "101agent",
      required: true,
    },
    lang: {
      type: Object,
    },
    mode: {
      type: String,
    },
    no_budget: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const userChatVisible = ref(true);
    if (props.mode == "qr") {
      userChatVisible.value = false;
    }
    const agentPhoto = toRef(props, "agent_photo_url");
    const agent_photo_ref = toRef(props, "agent_photo_url");
    watch(agent_photo_ref, (current_val) => {
      agentPhoto.value = current_val;
    });
    const chatMessagesData = ref(props.messages);
    const submitted = ref(false);
    const form = reactive({ message: "" });
    const current = ref(null); // Reference to chat container
    const fileInput = ref(null); // Reference input file

    const base64Data = ref("");

    const triggerFileInput = () => {
      fileInput.value.click(); // Trigger file input
    };
    const isShownTextToAgent = ref(false);
    eventBus.on("websocketHangup", () => {
      if (props.mode == "qr") {
        console.log("hiding chat");
        userChatVisible.value = false;
      }
    });

    const sprintf = (format, ...args) => {
      let i = 0;
      return format.replace(/%s|%d|%f/g, (match) => {
        let arg = args[i++];
        if (match === "%d") return parseInt(arg);
        if (match === "%f") return parseFloat(arg);
        return arg;
      });
    };

    const handleFileUpload = (event) => {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          base64Data.value = reader.result; // Base64 encoded string
          //console.log(base64Data.value);
          emit("onUploadFile", {
            file: file,
            data: base64Data.value,
          });
        };
      }
    };

    // Function to handle form submission
    const formSubmit = () => {
      submitted.value = true;

      if (form.message.trim() === "") return;

      const message = form.message;
      emit("onMsgSend", message);
      //eventBus.emit("customEvent", { message });

      const currentDate = new Date();
      chatMessagesData.value.push({
        align: "right",
        name: props.user,
        message,
        type: "text",
        time: currentDate.getHours() + ":" + currentDate.getMinutes(),
      });

      form.message = ""; // Reset message field
      submitted.value = false;

      handleScroll();
    };

    const handleScroll = () => {
      nextTick(() => {
        const wrapper = current.value?.$el.querySelector(
          ".simplebar-content-wrapper"
        );
        const lastMessage =
          current.value?.$el.querySelector("li.msg:last-child");

        if (!wrapper || !lastMessage) return;

        const scrollToLast = () => {
          const targetOffset = lastMessage.offsetTop;
          smoothScrollTo(wrapper, targetOffset);
        };

        const img = lastMessage.querySelector("img");

        if (img) {
          if (img.complete) {
            scrollToLast();
          } else {
            img.onload = scrollToLast;
            img.onerror = scrollToLast;
          }
        } else {
          scrollToLast();
        }
      });
    };

    const smoothScrollTo = (container, targetPosition, duration = 300) => {
      const start = container.scrollTop;
      const change = targetPosition - start;
      const startTime = performance.now();

      const animateScroll = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1); // Clamp between 0 and 1

        container.scrollTop = start + change * easeInOutQuad(progress);

        if (progress < 1) {
          requestAnimationFrame(animateScroll);
        }
      };

      const easeInOutQuad = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);

      requestAnimationFrame(animateScroll);
    };
    // Auto-scroll when a new message is added
    watchEffect(() => {
      if (chatMessagesData.value.length) {
        handleScroll();
      }
    });

    const minimizeChat = () => {
      if (props.mode == "qr") {
        toggleChatVisibility();
      } else {
        emit("minimize");
      }
    };
    onMounted(() => {
      eventBus.on("forcevisiblechat", () => {
        userChatVisible.value = true;
      });
      handleScroll();
    });

    const deactivate = () => {
      if (props.active) {
        emit("deactivateVoiceMode");
      }
    };
    const activate = () => {
      if (!props.active) {
        emit("activateVoiceMode");
      }
    };
    const toggleChatVisibility = () => {
      if (
        props.mode == "qr" &&
        isShownTextToAgent.value == true &&
        props.active
      ) {
        userChatVisible.value = !userChatVisible.value;
      }
    };
    const launch = () => {
      if (props.mode == "qr") {
        if (isShownTextToAgent.value == false) {
          isShownTextToAgent.value = true;
          activate();
        }
        if (!props.active) {
          activate();
        }
      }
    };
    return {
      v$: useVuelidate(),
      agentPhoto,
      formSubmit,
      chatMessagesData,
      form,
      current,
      minimizeChat,
      deactivate,
      activate,
      fileInput,
      handleFileUpload,
      triggerFileInput,
      userChatVisible,
      toggleChatVisibility,
      isShownTextToAgent,
      launch,
      sprintf,
    };
  },
  components: {
    simplebar,
    AudioPlayer,
    WaitAudio,
    iconsvg,
  },
};
</script>

<template>
  <div>
    <div class="w-100 user-chat position-relative">
      <div
        class="close-wrapper"
        v-if="mode != 'qr' || (mode == 'qr' && userChatVisible == true)"
      >
        <i
          class="icon-close"
          :style="{ '--pseudo-color2': colors.header_text }"
          @click="minimizeChat"
        ></i>
      </div>
      <BCard no-body>
        <div
          class="p-4 border-bottom chat-header"
          :style="{ backgroundColor: colors.headercolor }"
          @click="launch"
          :class="{
            'cursor-pointer':
              (!isShownTextToAgent && mode == 'qr') ||
              (!active && mode == 'qr'),
          }"
        >
          <img :src="logo101url" class="logo101" />
          <BRow>
            <BCol md="12" cols="12">
              <div class="agentinfo">
                <div
                  @click="toggleChatVisibility"
                  class="agentphoto"
                  :style="{ backgroundImage: `url(${agentPhoto})` }"
                  :class="{ 'cursor-pointer': mode == 'qr' }"
                ></div>
                <transition
                  enter-active-class="animate__animated animate__fadeIn animate__faster"
                  leave-active-class="animate__animated animate__fadeOut animate__faster"
                  mode="out-in"
                >
                  <h5
                    v-if="no_budget == true"
                    class="font-size-16 mb-1"
                    :style="{ color: colors.header_text }"
                  >
                    {{ lang.service_unavailable }}
                  </h5>

                  <h5
                    v-if="active && no_budget == false"
                    class="font-size-16 mb-1"
                    :style="{ color: colors.header_text }"
                  >
                    {{ agent_name }} {{ lang.is_listening }}
                  </h5>

                  <h5
                    v-if="
                      !active &&
                      isShownTextToAgent === false &&
                      mode === 'qr' &&
                      no_budget == false
                    "
                    class="font-size-16 mb-1"
                    :style="{ color: colors.header_text }"
                  >
                    {{ lang.press_to_talk }}
                  </h5>

                  <h5
                    v-if="
                      !active &&
                      no_budget == false &&
                      !(isShownTextToAgent === false && mode === 'qr')
                    "
                    class="font-size-16 mb-1"
                    :style="{ color: colors.header_text }"
                  >
                    <template v-if="mode !== 'qr'">
                      {{ agent_name }} {{ lang.has_stop_listening }}
                    </template>
                    <template v-if="mode === 'qr'">
                      {{ sprintf(lang.press_to_talk_again, agent_name) }}
                    </template>
                  </h5>
                </transition>
              </div>
            </BCol>
          </BRow>
        </div>
        <transition
          enter-active-class="animate__animated animate__fadeIn animate__faster"
          leave-active-class="animate__animated animate__fadeOut animate__faster"
          mode="out-in"
        >
          <div
            v-if="userChatVisible"
            class="chat-users"
            :style="{ borderColor: colors.bordercolor }"
          >
            <div class="chat-conversation p-3">
              <simplebar
                style="max-height: 500px; min-height: 500px"
                id="containerElement"
                ref="current"
              >
                <ul class="list-unstyled">
                  <li
                    v-for="data of chatMessagesData"
                    :key="data.message"
                    class="msg"
                    :class="{
                      right: `${data.align}` === 'right',
                      left: `${data.align}` !== 'right',
                    }"
                  >
                    <div class="conversation-list" v-if="data.type == 'text'">
                      <div class="ctext-wrap">
                        <div class="conversation-name">{{ data.name }}</div>
                        <p>{{ data.message }}</p>
                        <p class="chat-time mb-0">
                          <i class="bx bx-time-five align-middle me-1"></i>
                          {{ data.time }}
                        </p>
                      </div>
                    </div>
                    <wait-audio
                      v-else-if="data.type == 'waitaudio'"
                    ></wait-audio>
                    <audio-player
                      v-else-if="data.type == 'audio'"
                      :colors="colors"
                      :option="{
                        url: data.url,
                        waveColor: '#AAAAAA',
                        progressColor: '#7361FE',
                        height: 52,
                        barGap: 1,
                        barHeight: 5,
                        barWidth: 2,
                        barRadius: 2,
                        interact: true,
                        autoplay: false,
                        mediaControls: false,
                        cursorWidth: 0,
                        /*fetchParams: {
                        mode: 'no-cors',
                      },*/
                      }"
                      ref="audioPlayerRef"
                    ></audio-player>
                    <div
                      class="chat-day-title"
                      v-else-if="data.type == 'timeline'"
                    >
                      <span class="title">{{ data.name }}</span>
                    </div>
                    <div
                      class="conversation-list"
                      v-else-if="data.type == 'image'"
                    >
                      <div class="ctext-wrap">
                        <div class="conversation-name">{{ data.name }}</div>
                        <div
                          class="chat-image"
                          :style="{
                            backgroundImage: `url(${data.url})`,
                          }"
                        ></div>
                        <p class="image-filename">{{ data.filename }}</p>
                        <p class="chat-time mb-0">
                          <i class="bx bx-time-five align-middle me-1"></i>
                          {{ data.time }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="conversation-list"
                      v-else-if="data.type == 'file'"
                    >
                      <div class="ctext-wrap">
                        <div class="conversation-name">{{ data.name }}</div>
                        <i class="bx bx-file display-4"></i>
                        <p class="file-filename">{{ data.filename }}</p>
                        <p class="chat-time mb-0">
                          <i class="bx bx-time-five align-middle me-1"></i>
                          {{ data.time }}
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </simplebar>
            </div>
            <div class="p-3 chat-input-section">
              <BForm @submit.prevent="formSubmit" class="row">
                <BCol>
                  <div class="position-relative">
                    <input
                      type="file"
                      ref="fileInput"
                      @change="handleFileUpload"
                      class="d-none"
                    />
                    <input
                      type="text"
                      v-model="form.message"
                      class="form-control chat-input rounded"
                      :placeholder="lang.enter_message"
                    />
                    <div class="chat-input-links">
                      <ul class="list-inline mb-0">
                        <transition
                          enter-active-class="animate__animated animate__fadeIn animate__faster"
                          leave-active-class="animate__animated animate__fadeOut animate__faster"
                          mode="out-in"
                        >
                          <li class="list-inline-item" v-if="active">
                            <iconsvg
                              name="micon"
                              :color="colors.iconcolor"
                              @click="deactivate"
                            ></iconsvg>
                          </li>
                          <li class="list-inline-item" v-else>
                            <iconsvg
                              name="micoff"
                              :color="colors.iconcolor"
                              @click="activate"
                            ></iconsvg>
                          </li>
                        </transition>
                        <!-- <li class="list-inline-item">
                          <iconsvg
                            name="attach"
                            :color="colors.iconcolor"
                            @click="triggerFileInput"
                          ></iconsvg>
                        </li> -->
                        <li class="list-inline-item">
                          <iconsvg
                            name="send"
                            :color="colors.iconcolor"
                            @click="formSubmit"
                          ></iconsvg>
                        </li>
                      </ul>
                    </div>
                  </div>
                </BCol>
              </BForm>
            </div>
          </div>
        </transition>
      </BCard>
    </div>
  </div>
</template>
<style scoped>
.icon-close:after {
  background-color: var(--pseudo-color2);
}
.icon-close:before {
  background-color: var(--pseudo-color2);
}
.close-wrapper {
  top: 2px;
  right: 2px;
}
</style>
